(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/shared/components/top-title.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/shared/components/top-title.js');
'use strict';

const TopTitle = _ref => {
  let children = _ref.children;
  return React.createElement("h2", {
    className: "h2 margin-bottom-1 align-center"
  }, React.createElement("span", {
    className: "f-medium"
  }, children));
};
svs.myProfile.react.shared.components.TopTitle = TopTitle;

 })(window);